import Vue from 'vue'
import Vuex from 'vuex'
import {warehouseCollection, db} from '@/FirebaseConfig'
import {cleanObject, secondsToFullTimestamp, toSlug} from '@/Helper'
Vue.use(Vuex)
export default {
    namespaced: true,
    state:{
        data:{
            name:'',
            location:'',
            attendant:'',
            isMain: false,
        },
        selectedKey:'',
        record:{},
        dialog: false,
    },
    mutations:{
        getAllItems(state, item) {
            Vue.set( state.record, item.id, {...item.data(), createdAt: secondsToFullTimestamp(item.data().createdAt)} )
        },
        clean(state,key){
            Vue.delete(state.record,key)
        }
    },
    actions:{
        getAll:context=>{
            context.state.record = {}
            warehouseCollection.orderBy('name').onSnapshot(data=>data.docs.map( item => context.commit( 'getAllItems',item  ) ) )  
        },
        add:context=>{
            if(context.state.selectedKey==''){
              warehouseCollection.add({...context.state.data, name: context.state.data.name.toUpperCase(), createdAt:new Date, slug: toSlug(context.state.data.name)}).then(()=>{
                context.commit('Helpers/launchSnackbar', 'Se ha añadido un nuevo almacén', { root: true })                  
                cleanObject(context.state.data)
                context.state.dialog = false
            })
            }else{
              warehouseCollection.doc(context.state.selectedKey).update({...context.state.data, name: context.state.data.name.toUpperCase()}).then(()=>{
                context.commit('Helpers/launchSnackbar', 'Actualizado correctamente', { root: true })            
                cleanObject(context.state.data)
                context.state.dialog = false
                })
            }

        },
        clean:(context, key)=>{
            warehouseCollection.doc(key).delete().then(()=>{
            context.commit('Helpers/launchSnackbar', 'Se ha eliminado con éxito', { root: true })            
            context.commit('clean',key)})
        },
        get:(context, key)=>{
            warehouseCollection.doc(key).get().then(doc=>{
              context.state.data = doc.data()
              context.state.selectedKey = key
              context.state.dialog = true
            })
        },
        massiveAdd: (context, data) =>{
            let batch = db.batch()
            let count = 0
            data.map(item => {
                batch.set(warehouseCollection.doc(), {...item, slug: toSlug(item.name), createdAt: new Date()})
                count++   
            })
            batch.commit().then( () =>  context.commit('Helpers/launchSnackbar', `Se han hecho ${count} registros`, { root: true }) )
        },
        getMainWarehouse: async (context) =>{
            let warehouses = await warehouseCollection.where('isMain', '==', true).get()
            console.log(warehouses)
            if(warehouses.empty) {
                context.commit('Helpers/launchSnackbar', 'No ha sido indicado cuál es el almacén principal', { root: true })
                return false
            }
            let arr = []
            arr.push({
                name: warehouses.docs[0].data().name,
                slug: warehouses.docs[0].data().slug,
            })
            console.log(arr)
            return arr
            
        },
        getTotalWarehouse: async (context) =>{
            let warehouses = await warehouseCollection.where('isTotal', '==', true).get()
            if(warehouses.empty) {
                context.commit( 'Helpers/launchSnackbar', 'No se ha registrado un almacén total' , { root: true })
                return false
            }
            
            let arr = []
            arr.push({
                name: warehouses.docs[0].data().name,
                slug: warehouses.docs[0].data().slug,
            })
            return arr
            
        },
        clearForm:(context)=>{
            context.state.dialog = false
            context.state.selectedKey = ''
            context.state.data = {
              name: '',
              createdAt: '',
              direcciones: []
            }
          },
    },
    getters: {
        record: state => Object.keys(state.record).map(item => ({...state.record[item], key: item }) ),
    },
}